// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media screen and (max-width: 1024px) {\n.footer-with-ads[data-v-37b5decc] {\r\n\t\tpadding-bottom: 7rem;\r\n\t\tmargin-top: -4.4375rem;\n}\n.footer-no-ads[data-v-37b5decc] {\r\n\t\tpadding-bottom: 3rem;\r\n\t\tmargin-top: -4.4375rem;\n}\n}\n.hide-app-footer[data-v-37b5decc] {\r\n\tdisplay: none;\n}\r\n", ""]);
// Exports
module.exports = exports;
